import { ObservedValueOf, of, OperatorFunction, Observable, combineLatest } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import { Multi } from "../../../interfaces/multi.interface";
import { Single } from "../../../interfaces/single.interface";


export function NgxMultiSingleNameFunc(multiSingleNameFunc: MultiSingleNameFunc): OperatorFunction<Multi[], Multi[]> {

 

  return map(multis => {
    const newMultis = multis.map((m, index) => {
      const newMulti: Multi = Object.assign({}, m, { series: m.series.map(s => Object.assign({}, s, { name: multiSingleNameFunc (s, m)})) });
      return newMulti;
    });

    return newMultis;
  });
}



interface MultiSingleNameFunc {
  (single: Single, multi:Multi): String;
}
